class InvestorDTO {
    constructor(params) {
        this.articleLink = params.articleLink;
        this.centerImage = params.url + params.centerImage;
        this.date = params.date;
        this.description = params.description;
        this.externalId = params.externalId;
        this.id = params.id;
        this.link = params.link;
        this.rank = params.rank;
        this.url = params.url;
        this.videoLink = params.videoLink;
    }
}
export default InvestorDTO;
